import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';
import LinkExternal from '../components/Link/LinkExternal';
import { ipfsPrfix } from '../configs';

import './ScreenTerms.scss';



function ScreenIpfs() {
  return (
    <section className="section-terms">
      <div className="container" data-aos="fade-in" data-delay="200">
        <div className="pre-title">
          <Link className="pre-title-back" to="/">&larr; Go to homepage</Link>
        </div>

        <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
            <h1 className="title">Roborovski NFT IPFS Storage</h1>
            <p>You can also store this data in your IPFS hosting.</p>

            <br />
            <div className="textpage">
              <h2 className="title">Metadata</h2>
              <p><LinkExternal href={`${ipfsPrfix}QmTPKnNZGeHEhxCGJXoCpVXRc4PUrgi8YxyL5fQYjDQ5nb`}>QmTPKnNZGeHEhxCGJXoCpVXRc4PUrgi8YxyL5fQYjDQ5nb</LinkExternal></p>

              <h2 className="title">Images (2000x2000)</h2>
              <p><LinkExternal href={`${ipfsPrfix}QmWbG8WuXuAyaP8oA129k5jj9prtPbyxxyW7PF5a3ouiLP`}>QmWbG8WuXuAyaP8oA129k5jj9prtPbyxxyW7PF5a3ouiLP</LinkExternal></p>

              <h2 className="title">Images (720x720)</h2>
              <p><LinkExternal href={`${ipfsPrfix}QmUvvSQJqpVqD89BUu6PMyWSoBFZy9JUzX9gaQeUWofj9T`}>QmUvvSQJqpVqD89BUu6PMyWSoBFZy9JUzX9gaQeUWofj9T</LinkExternal></p>

              <h2 className="title">Images (360x360)</h2>
              <p><LinkExternal href={`${ipfsPrfix}QmZweRBW9SNDQrGLoBAiGqxeVmioc55mPepPCHBhENBmvJ`}>QmZweRBW9SNDQrGLoBAiGqxeVmioc55mPepPCHBhENBmvJ</LinkExternal></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default hot(module)(ScreenIpfs);
